import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthFacade } from '@store-common/facade/auth-facade';
import { WINDOW_LOCATION_STORAGE_KEY } from '@infrastructure/tokens/local-storage.const';
import { MAIN_ROUTES } from '@infrastructure/routes/main.route';
import Keycloak from 'keycloak-js';

export const authGuard: CanActivateFn = async (route) => {
  const keycloak = inject(Keycloak);
  const authFacade = inject(AuthFacade);
  const router = inject(Router);

  const isAuth = keycloak?.authenticated;

  const token = keycloak?.tokenParsed;

  const roles = token?.resource_access?.['custody-rest-api']?.roles || [];

  if (!isAuth) {
    const location =
      localStorage.getItem(WINDOW_LOCATION_STORAGE_KEY) ?? window.location.origin;

    localStorage.removeItem(WINDOW_LOCATION_STORAGE_KEY);

    await keycloak?.login({
      redirectUri: location,
    });
  }

  const requiredRoles = route.data['roles'];

  authFacade.getUser();
  authFacade.setRoles(roles);

  const canLoad = requiredRoles.some((role) => roles.includes(role));

  if (!canLoad) {
    router.navigate(['/', MAIN_ROUTES.DENIED]);
  }

  return canLoad;
};
